var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _g11, _path12, _path13, _g12, _path14, _g13, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmergenteTres(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 132,
    viewBox: "0 0 120 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3191_33571",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 115,
    width: 10,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5691 115.094C61.3134 116.389 64.0044 121.048 64.1476 121.292C62.8665 122.036 61.4351 122.401 60.0037 122.401C58.5723 122.401 57.141 122.029 55.8599 121.292C56.003 121.048 58.694 116.389 59.4383 115.094C59.6101 115.194 59.8033 115.244 60.0037 115.244C60.2041 115.244 60.3902 115.194 60.5691 115.094Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3191_33571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.5689 115.094C61.3132 116.389 64.0042 121.048 64.1473 121.292C62.8662 122.036 61.4349 122.401 60.0035 122.401C58.5721 122.401 57.1407 122.029 55.8596 121.292C56.0028 121.048 58.6938 116.389 59.4381 115.094C59.6098 115.194 59.8031 115.244 60.0035 115.244C60.2039 115.244 60.3899 115.194 60.5689 115.094Z",
    fill: "#788C7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4381 115.094C59.6098 115.194 59.8031 115.244 60.0035 115.244C60.2039 115.244 60.3899 115.194 60.5689 115.094C61.2774 116.325 63.7394 120.583 64.1044 121.22C64.0686 121.263 64.0257 121.313 63.9899 121.356L63.9183 121.42C62.6945 122.072 61.349 122.401 60.0035 122.401C58.5721 122.401 57.1407 122.029 55.8596 121.292C56.0028 121.048 58.6938 116.389 59.4381 115.094Z",
    fill: "#788C7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4381 115.094C59.6098 115.194 59.8031 115.244 60.0035 115.244C60.2039 115.244 60.3899 115.194 60.5689 115.094C61.1772 116.153 63.0881 119.452 63.8396 120.762C63.8109 120.819 63.7752 120.905 63.7465 120.962C63.6249 121.177 63.403 121.578 62.945 121.864C62.0002 122.222 61.0054 122.401 60.0035 122.401C58.5721 122.401 57.1407 122.029 55.8596 121.292C56.0028 121.048 58.6938 116.389 59.4381 115.094Z",
    fill: "#778A7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4382 115.094C59.6099 115.194 59.8032 115.244 60.0035 115.244C60.2039 115.244 60.39 115.194 60.5689 115.094C61.0986 116.017 62.623 118.658 63.5033 120.182C63.2099 121.141 62.5872 121.893 61.8214 122.201C61.2202 122.337 60.6119 122.401 59.9964 122.401C58.565 122.401 57.1336 122.029 55.8525 121.292C55.9957 121.048 58.6867 116.389 59.431 115.094",
    fill: "#75897C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4381 115.094C59.6098 115.194 59.8031 115.244 60.0035 115.244C60.2039 115.244 60.3899 115.194 60.5689 115.094C61.0412 115.902 62.2722 118.042 63.1597 119.588C63.1454 119.638 63.1239 119.71 63.1167 119.76C62.7804 121.091 61.6853 122.201 60.5116 122.394C60.3398 122.401 60.1752 122.408 60.0035 122.408C58.5721 122.408 57.1407 122.036 55.8596 121.299C56.0028 121.055 58.6938 116.396 59.4381 115.101",
    fill: "#74877A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4381 115.094C59.6098 115.194 59.8031 115.244 60.0035 115.244C60.2039 115.244 60.3899 115.194 60.5689 115.094C60.984 115.809 61.9859 117.549 62.8305 119.009C62.8161 119.073 62.7947 119.152 62.7804 119.216C62.3796 121.07 60.6834 122.437 58.9156 122.329C57.8564 122.186 56.8115 121.843 55.8596 121.292C56.0028 121.048 58.6938 116.389 59.4381 115.094Z",
    fill: "#728579"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4382 115.094C59.6099 115.194 59.8032 115.244 60.0035 115.244C60.2039 115.244 60.39 115.194 60.5689 115.094C60.9339 115.716 61.7498 117.133 62.5085 118.457C62.4942 118.515 62.4798 118.593 62.4727 118.651C62.0719 120.941 59.6385 122.78 56.7973 121.764C56.4752 121.628 56.1603 121.471 55.8525 121.299C55.9957 121.055 58.6867 116.396 59.431 115.101",
    fill: "#718377"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4382 115.094C59.61 115.194 59.8032 115.244 60.0036 115.244C60.204 115.244 60.3901 115.194 60.569 115.094C60.8839 115.638 61.5424 116.783 62.2151 117.942C62.2151 117.971 62.2079 118.007 62.2008 118.028C61.7642 120.905 58.6724 122.437 55.96 121.12C56.4824 120.218 58.7655 116.267 59.4382 115.094Z",
    fill: "#6F8175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4382 115.094C59.61 115.194 59.8032 115.244 60.0036 115.244C60.204 115.244 60.3901 115.194 60.569 115.094C60.841 115.566 61.3634 116.475 61.936 117.456C61.936 117.506 61.9217 117.57 61.9145 117.62C61.5352 119.989 59.0088 121.822 56.189 120.712C56.9619 119.374 58.837 116.132 59.4382 115.087",
    fill: "#6D8074"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.438 115.094C59.6098 115.194 59.803 115.244 60.0034 115.244C60.2038 115.244 60.3899 115.194 60.5688 115.094C60.7978 115.487 61.2057 116.203 61.6709 117.005C61.6709 117.048 61.6566 117.105 61.6495 117.148C61.263 119.61 58.9012 121.005 56.4822 120.197C57.3625 118.679 58.8941 116.017 59.4308 115.094",
    fill: "#6C7E72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4382 115.094C59.61 115.194 59.8032 115.244 60.0036 115.244C60.204 115.244 60.3901 115.194 60.569 115.094C60.7551 115.416 61.0628 115.953 61.4278 116.582C61.4278 116.618 61.4135 116.668 61.4135 116.711C61.0771 118.93 58.9802 120.268 56.8259 119.624C57.7205 118.085 58.9658 115.924 59.4382 115.101",
    fill: "#6A7C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4382 115.094C59.61 115.194 59.8032 115.244 60.0036 115.244C60.204 115.244 60.3901 115.194 60.569 115.094C60.7121 115.344 60.934 115.724 61.1916 116.167C61.1916 116.196 61.1845 116.239 61.1773 116.275C60.891 118.264 59.1448 119.452 57.1909 118.98C58.0283 117.527 59.0231 115.802 59.4382 115.094Z",
    fill: "#697A6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.438 115.094C59.6098 115.194 59.803 115.244 60.0034 115.244C60.2038 115.244 60.3899 115.194 60.5688 115.094C60.669 115.266 60.805 115.495 60.9625 115.774C60.9625 115.802 60.9553 115.831 60.9481 115.86C60.8122 116.532 60.6762 117.234 59.7744 117.885C58.9084 118.515 57.9494 118.357 57.5916 118.293C58.3287 117.019 59.0945 115.695 59.438 115.094Z",
    fill: "#67786D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4382 115.094C59.6099 115.194 59.8032 115.244 60.0036 115.244C60.2039 115.244 60.39 115.194 60.5689 115.094C60.6119 115.172 60.6691 115.266 60.7264 115.366C60.7264 115.38 60.7192 115.409 60.7121 115.423C60.5546 116.16 60.4616 116.568 59.796 117.091C59.1948 117.563 58.5221 117.541 58.0354 117.52C58.6151 116.511 59.159 115.573 59.4382 115.094Z",
    fill: "#66766B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3191_33571",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 88,
    width: 50,
    height: 34
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.345 88.6689C107.09 89.9643 109.788 94.6235 109.924 94.8668L64.148 121.297C64.0049 121.054 61.3139 116.395 60.5696 115.099L106.345 88.6761V88.6689Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3191_33571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.5696 115.092L106.345 88.6689C106.388 88.7477 106.445 88.8407 106.503 88.9409L60.727 115.364C60.6698 115.264 60.6125 115.171 60.5696 115.092Z",
    fill: "#66766B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7271 115.364L106.503 88.9404C106.574 89.0621 106.653 89.1981 106.739 89.3412L60.9632 115.772C60.8773 115.621 60.7986 115.485 60.7271 115.371",
    fill: "#67786D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9631 115.772L106.739 89.3418C106.81 89.4706 106.889 89.5994 106.968 89.7426L61.1922 116.173C61.1134 116.03 61.0347 115.901 60.9631 115.772Z",
    fill: "#697A6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1924 116.173L106.968 89.7422C107.047 89.871 107.125 90.007 107.204 90.1501L61.4286 116.581C61.3498 116.437 61.2711 116.301 61.1924 116.173Z",
    fill: "#6A7C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4282 116.581L107.204 90.1504C107.283 90.2864 107.368 90.4295 107.447 90.5798L61.6716 117.01C61.5857 116.867 61.5069 116.724 61.4282 116.581Z",
    fill: "#6C7E72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6719 117.011L107.448 90.5801C107.533 90.7304 107.619 90.8807 107.705 91.031L61.9295 117.461C61.8436 117.311 61.7506 117.161 61.6719 117.011Z",
    fill: "#6D8074"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9365 117.461L107.712 91.0303C107.805 91.1877 107.898 91.3523 107.991 91.5098L62.2156 117.94C62.1226 117.776 62.0296 117.618 61.9365 117.461Z",
    fill: "#6F8175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2156 117.94L107.991 91.5098C108.091 91.6815 108.192 91.8533 108.285 92.0251L62.509 118.456C62.4088 118.284 62.3086 118.112 62.2156 117.94Z",
    fill: "#718377"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.509 118.456L108.285 92.0254C108.392 92.2115 108.499 92.3904 108.6 92.5693L62.8239 119C62.7237 118.821 62.6164 118.635 62.509 118.456Z",
    fill: "#728579"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.824 119L108.6 92.5693C108.714 92.7697 108.829 92.963 108.936 93.1562L63.1604 119.587C63.053 119.401 62.9385 119.207 62.824 119Z",
    fill: "#74877A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1604 119.586L108.936 93.1553C109.058 93.37 109.172 93.5704 109.28 93.7493L63.5039 120.18C63.3966 119.994 63.2821 119.793 63.1604 119.579",
    fill: "#75897C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5112 120.18L109.287 93.75C109.416 93.9647 109.523 94.1651 109.623 94.3297L63.8476 120.76C63.7546 120.596 63.6401 120.402 63.5112 120.18Z",
    fill: "#778A7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8403 120.761L109.616 94.3301C109.738 94.5376 109.824 94.6951 109.881 94.781L64.1051 121.211C64.055 121.118 63.962 120.968 63.8403 120.761Z",
    fill: "#788C7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.105 121.212L109.881 94.7812L109.924 94.86L64.1479 121.29L64.105 121.212Z",
    fill: "#7A8E81"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3191_33571",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 88,
    width: 50,
    height: 34
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4381 115.095C58.6938 116.39 55.9956 121.049 55.8596 121.292L10.084 94.8619C10.2271 94.6186 12.9181 89.9595 13.6624 88.6641L59.4452 115.095H59.4381Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3191_33571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6552 88.6641L59.438 115.095C59.1589 115.574 58.6149 116.512 58.0352 117.521L12.2524 91.0903C12.8322 90.0811 13.3761 89.1436 13.6552 88.6641Z",
    fill: "#66766B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2594 91.0898L58.0422 117.52C57.8919 117.778 57.7416 118.036 57.5913 118.293L11.8157 91.8628C11.966 91.6051 12.1163 91.3403 12.2666 91.0898",
    fill: "#67786D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8087 91.8711L57.5843 118.302C57.4483 118.531 57.3195 118.76 57.1907 118.989L11.415 92.5582C11.5439 92.3363 11.6798 92.1073 11.8087 91.8711Z",
    fill: "#697A6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4151 92.5498L57.1907 118.98C57.0619 119.202 56.9402 119.41 56.8257 119.617L11.05 93.1868C11.1646 92.9864 11.2934 92.7717 11.4151 92.5498Z",
    fill: "#6A7C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.05 93.1875L56.8256 119.618C56.704 119.826 56.5895 120.026 56.4893 120.205L10.7136 93.7744C10.821 93.5954 10.9283 93.3951 11.05 93.1875Z",
    fill: "#6C7E72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7064 93.7734L56.482 120.204C56.3746 120.397 56.2744 120.569 56.1814 120.719L10.4058 94.2887C10.4916 94.1384 10.5918 93.9667 10.7064 93.7734Z",
    fill: "#6D8074"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4131 94.2891L56.1887 120.72C56.0957 120.884 56.017 121.02 55.9597 121.12L10.1841 94.6898C10.2413 94.5897 10.3201 94.4537 10.4131 94.2891Z",
    fill: "#6F8175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1769 94.6904L55.9525 121.121C55.9024 121.214 55.8666 121.271 55.8523 121.293L10.0767 94.8622C10.0767 94.8622 10.1268 94.7763 10.1769 94.6904Z",
    fill: "#718377"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3191_33571",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 87,
    width: 9,
    height: 8
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.917 87.6797C108.413 87.6797 113.788 87.6797 114.074 87.6797C114.074 90.6427 112.493 93.3766 109.923 94.8652C109.78 94.6219 107.089 89.9627 106.345 88.6673C106.703 88.4598 106.917 88.0876 106.917 87.6797Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3191_33571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.917 87.6797C108.413 87.6797 113.788 87.6797 114.074 87.6797C114.074 90.6427 112.492 93.3766 109.923 94.8652C109.78 94.6219 107.089 89.9627 106.344 88.6673C106.702 88.4598 106.917 88.0876 106.917 87.6797Z",
    fill: "#869D8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.344 88.6673C106.702 88.4598 106.917 88.0876 106.917 87.6797C108.134 87.6797 111.92 87.6797 113.444 87.6797C113.952 87.8729 113.967 87.8801 114.074 87.9302C113.988 90.7929 112.421 93.4195 109.93 94.8652C109.787 94.6219 107.096 89.9627 106.352 88.6673",
    fill: "#869D8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.344 88.6673C106.702 88.4598 106.917 88.0876 106.917 87.6797C107.797 87.6797 110.03 87.6797 111.769 87.6797C113.616 88.6387 113.859 88.9035 113.967 89.018C113.566 91.4514 112.099 93.6056 109.93 94.8581C109.787 94.6147 107.096 89.9556 106.352 88.6602",
    fill: "#859B8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.344 88.6673C106.702 88.4598 106.917 88.0876 106.917 87.6797C107.633 87.6797 109.243 87.6797 110.753 87.6797C112.013 88.3954 113.444 89.4188 113.745 89.9985C113.151 92.0239 111.805 93.7774 109.93 94.8652C109.787 94.6219 107.096 89.9627 106.352 88.6673",
    fill: "#83998B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.344 88.6673C106.702 88.4598 106.917 88.0876 106.917 87.6797C107.518 87.6797 108.756 87.6797 110.03 87.6797C112.041 88.9465 113.258 90.2562 113.423 90.9003C112.728 92.5392 111.519 93.942 109.923 94.8652C109.78 94.6219 107.089 89.9627 106.344 88.6673Z",
    fill: "#829789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.344 88.6673C106.702 88.4598 106.917 88.0876 106.917 87.6797C107.425 87.6797 108.391 87.6797 109.458 87.6797C111.548 89.0252 113.008 90.8931 113.022 91.7305C112.306 93.0116 111.247 94.1066 109.93 94.8652C109.787 94.6219 107.096 89.9627 106.352 88.6673",
    fill: "#809587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.344 88.6673C106.702 88.4598 106.917 88.0876 106.917 87.6797C107.354 87.6797 108.112 87.6797 108.985 87.6797C111.483 89.3186 112.771 91.7878 112.528 92.5034C111.848 93.4553 110.968 94.2641 109.93 94.8652C109.787 94.6219 107.096 89.9627 106.352 88.6673",
    fill: "#7F9386"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.344 88.6673C106.702 88.4598 106.917 88.0876 106.917 87.6797C107.282 87.6797 107.89 87.6797 108.592 87.6797C111.254 89.4832 112.378 92.3889 111.956 93.212C111.376 93.8561 110.696 94.4143 109.923 94.8581C109.78 94.6147 107.089 89.9556 106.344 88.6602",
    fill: "#7D9284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.344 88.6673C106.702 88.4598 106.917 88.0876 106.917 87.6797C107.225 87.6797 107.697 87.6797 108.255 87.6797C111.111 89.6979 111.948 92.9472 111.297 93.8704C110.882 94.2426 110.424 94.579 109.923 94.8652C109.78 94.6219 107.089 89.9627 106.344 88.6673Z",
    fill: "#7B9083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.344 88.6673C106.702 88.4598 106.917 88.0876 106.917 87.6797C107.168 87.6797 107.533 87.6797 107.969 87.6797C110.782 89.7337 111.54 93.2549 110.553 94.4644C110.352 94.6076 110.145 94.7364 109.93 94.8652C109.787 94.6219 107.096 89.9627 106.352 88.6673",
    fill: "#7A8E81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.344 88.6673C106.702 88.4598 106.917 88.0876 106.917 87.6797C107.117 87.6797 107.389 87.6797 107.704 87.6797C110.474 89.7123 111.004 93.4338 109.88 94.7865C109.494 94.1209 107.053 89.8912 106.344 88.6673Z",
    fill: "#788C7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.344 88.6673C106.702 88.4598 106.917 88.0876 106.917 87.6797C107.067 87.6797 107.261 87.6797 107.482 87.6797C109.551 89.2113 110.51 92.1957 109.615 94.3285C108.857 93.0187 106.953 89.7194 106.344 88.6673Z",
    fill: "#778A7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.344 88.6673C106.702 88.4598 106.917 88.0876 106.917 87.6797C107.024 87.6797 107.146 87.6797 107.282 87.6797C109.35 89.2828 109.851 91.9452 109.286 93.7488C108.406 92.2243 106.881 89.5906 106.352 88.6673",
    fill: "#75897C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.344 88.6673C106.702 88.4598 106.917 88.0876 106.917 87.6797C106.974 87.6797 107.039 87.6797 107.103 87.6797C108.699 88.9608 109.4 91.0578 108.935 93.1547C108.048 91.616 106.81 89.4761 106.344 88.6673Z",
    fill: "#74877A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.344 88.6673C106.702 88.4598 106.917 88.0876 106.917 87.6797H106.953C107.762 88.3739 109.05 89.927 108.606 92.575C107.762 91.1222 106.76 89.383 106.344 88.6673Z",
    fill: "#728579"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.344 88.6674C106.674 88.4742 106.881 88.1378 106.91 87.7656C106.917 87.7728 106.931 87.7871 106.946 87.7943C108.076 88.8821 108.542 90.3421 108.284 92.0168C107.518 90.7 106.702 89.2829 106.344 88.6602",
    fill: "#718377"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.345 88.6671C106.638 88.4954 106.838 88.2091 106.896 87.8799C106.903 87.8942 106.917 87.9085 106.931 87.9157C108.177 89.2898 108.084 90.8858 107.983 91.5084C107.318 90.349 106.652 89.2111 106.337 88.6671",
    fill: "#6F8175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.344 88.6672C106.609 88.5169 106.795 88.2664 106.874 87.9873C106.881 88.0016 106.896 88.0159 106.91 88.0302C107.754 89.1181 107.812 90.2632 107.711 91.029C107.146 90.0485 106.616 89.1324 106.344 88.6672Z",
    fill: "#6D8074"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.344 88.6673C106.574 88.5313 106.745 88.3309 106.838 88.0947C106.845 88.109 106.86 88.1234 106.867 88.1377C107.468 89.0681 107.504 89.8625 107.447 90.571C106.981 89.7694 106.574 89.0538 106.344 88.6601",
    fill: "#6C7E72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.344 88.6673C106.538 88.5528 106.688 88.3954 106.788 88.2021C106.788 88.2165 106.803 88.2308 106.81 88.2379C107.139 88.8749 107.253 89.4045 107.203 90.1488C106.845 89.5262 106.531 88.9894 106.344 88.6673Z",
    fill: "#6A7C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.345 88.6671C106.502 88.5741 106.631 88.4595 106.724 88.3164C106.724 88.3164 106.724 88.3236 106.724 88.3307C106.867 88.6886 106.996 89.0965 106.96 89.7478C106.702 89.2969 106.481 88.9247 106.337 88.6743",
    fill: "#697A6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.344 88.6668C106.452 88.6024 106.552 88.5237 106.631 88.4307C106.631 88.445 106.638 88.4664 106.645 88.4808C106.709 88.767 106.745 88.9961 106.738 89.3467C106.581 89.0748 106.445 88.8458 106.344 88.6668Z",
    fill: "#67786D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.344 88.6676C106.395 88.639 106.445 88.6032 106.495 88.5674C106.495 88.5674 106.495 88.5745 106.495 88.5817C106.495 88.7034 106.502 88.825 106.502 88.9467C106.445 88.8465 106.387 88.7535 106.344 88.6747",
    fill: "#66766B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_3191_33571",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 87,
    width: 9,
    height: 8
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6553 88.6634C12.9109 89.9588 10.2199 94.618 10.0768 94.8613C7.51462 93.3798 5.92578 90.6459 5.92578 87.6758C6.21206 87.6758 11.5869 87.6758 13.0827 87.6758C13.0827 88.0837 13.2974 88.4559 13.6553 88.6563V88.6634Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_3191_33571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6553 88.6644C12.9109 89.9598 10.2199 94.619 10.0768 94.8623C7.51462 93.3808 5.92578 90.6469 5.92578 87.6768C6.21206 87.6768 11.5869 87.6768 13.0827 87.6768C13.0827 88.0847 13.2974 88.4569 13.6553 88.6573",
    fill: "#718377"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0898 87.6836C13.0898 88.0915 13.3045 88.4637 13.6623 88.6641C12.918 89.9595 10.227 94.6186 10.0839 94.862C8.07995 93.7026 6.67719 91.7773 6.15474 89.5802C6.14042 89.5086 6.12611 89.4156 6.11895 89.344C6.05454 88.5353 6.09032 88.3134 6.21199 87.6836C7.37857 87.6836 11.7658 87.6836 13.0969 87.6836",
    fill: "#718377"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.09 87.6836C13.09 88.0915 13.3047 88.4637 13.6625 88.6641C12.9826 89.8378 10.7067 93.7813 10.1843 94.6902C10.0698 94.633 9.91946 94.5614 9.81211 94.5113C6.86346 92.7936 6.01894 89.7806 6.71316 87.6836C8.31631 87.6836 11.9162 87.6836 13.0971 87.6836",
    fill: "#6F8175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0898 87.6836C13.0898 88.0915 13.3045 88.4637 13.6624 88.6641C13.0612 89.709 11.1861 92.9511 10.4203 94.2894C10.3988 94.2823 10.3702 94.268 10.3487 94.2608C8.05852 93.266 6.21919 90.6179 7.32136 87.6836C9.09627 87.6836 12.0521 87.6836 13.097 87.6836",
    fill: "#6D8074"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0899 87.6836C13.0899 88.0915 13.3046 88.4637 13.6624 88.6641C13.1257 89.5945 11.5941 92.2497 10.7138 93.7741C10.6136 93.7312 10.4776 93.6811 10.3703 93.6453C7.97985 92.4859 6.95641 89.9237 7.97985 87.6836C9.75477 87.6836 12.1666 87.6836 13.0899 87.6836Z",
    fill: "#6C7E72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0899 87.6836C13.0899 88.0915 13.3046 88.4637 13.6625 88.6641C13.1901 89.48 11.9448 91.6414 11.0502 93.1873C8.4093 92.2425 7.69361 89.573 8.67411 87.6836C10.3345 87.6836 12.2812 87.6836 13.0899 87.6836Z",
    fill: "#6A7C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.09 87.6836C13.09 88.0915 13.3047 88.4637 13.6625 88.6641C13.2546 89.3726 12.2598 91.0974 11.4153 92.5503C11.3294 92.5217 11.222 92.4859 11.1361 92.4572C9.13935 91.6056 8.39503 89.5515 9.38984 87.6836C10.8642 87.6836 12.3957 87.6836 13.09 87.6836Z",
    fill: "#697A6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0898 87.6839C13.0898 88.0919 13.3045 88.464 13.6624 88.6644C13.3189 89.2656 12.5459 90.5896 11.8159 91.8636C11.7443 91.8421 11.6441 91.8063 11.5726 91.7848C10.1054 91.2123 9.09627 89.5805 10.134 87.6768C11.3579 87.6768 12.5173 87.6768 13.0898 87.6768",
    fill: "#67786D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0897 87.6836C13.0897 88.0915 13.3044 88.4637 13.6622 88.6641C13.3831 89.1436 12.8392 90.0883 12.2595 91.0903C12.2022 91.0688 12.1235 91.0473 12.0591 91.0259C11.1287 90.7038 10.7708 90.0096 10.6491 89.6303C10.3629 88.7643 10.735 88.0844 10.9569 87.6836C11.8587 87.6836 12.6459 87.6836 13.0968 87.6836",
    fill: "#66766B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_3191_33571",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 34,
    width: 9,
    height: 54
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.09 87.6813C11.5942 87.6813 6.21938 87.6813 5.93311 87.6813V34.8203C6.21938 34.8203 11.5942 34.8203 13.09 34.8203V87.6741V87.6813Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_3191_33571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0899 34.8203V87.6741C12.6461 87.6741 11.8517 87.6741 10.95 87.6741V34.8203C11.8517 34.8203 12.6461 34.8203 13.0899 34.8203Z",
    fill: "#66766B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9428 34.8203V87.6741C10.678 87.6741 10.4061 87.6741 10.127 87.6741V34.8203C10.4061 34.8203 10.678 34.8203 10.9428 34.8203Z",
    fill: "#67786D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1342 34.8203V87.6741C9.88372 87.6741 9.64038 87.6741 9.38989 87.6741V34.8203C9.64038 34.8203 9.89088 34.8203 10.1342 34.8203Z",
    fill: "#697A6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39001 34.8203V87.6741C9.14667 87.6741 8.91049 87.6741 8.67432 87.6741V34.8203C8.91049 34.8203 9.14667 34.8203 9.39001 34.8203Z",
    fill: "#6A7C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67445 34.8203V87.6741C8.43827 87.6741 8.20209 87.6741 7.98022 87.6741V34.8203C8.20209 34.8203 8.43827 34.8203 8.67445 34.8203Z",
    fill: "#6C7E72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9798 34.8203V87.6741C7.74362 87.6741 7.52176 87.6741 7.31421 87.6741V34.8203C7.52176 34.8203 7.74362 34.8203 7.9798 34.8203Z",
    fill: "#6D8074"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.31439 34.8203V87.6741C7.09253 87.6741 6.88498 87.6741 6.70605 87.6741V34.8203C6.88498 34.8203 7.09253 34.8203 7.31439 34.8203Z",
    fill: "#6F8175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.70606 34.8203V87.6741C6.50567 87.6741 6.3339 87.6741 6.20508 87.6741V34.8203C6.3339 34.8203 6.50567 34.8203 6.70606 34.8203Z",
    fill: "#718377"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.20507 34.8203V87.6741C6.05477 87.6741 5.96173 87.6741 5.93311 87.6741V34.8203C5.93311 34.8203 6.06193 34.8203 6.20507 34.8203Z",
    fill: "#728579"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_3191_33571",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 34,
    width: 9,
    height: 54
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.917 34.8203C108.413 34.8203 113.788 34.8203 114.074 34.8203V87.6741C113.788 87.6741 108.413 87.6741 106.917 87.6741V34.8203Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_3191_33571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.917 87.6813V34.8203H106.953V87.6741H106.917",
    fill: "#728579"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.953 87.6813V34.8203C107.003 34.8203 107.054 34.8203 107.104 34.8203V87.6741C107.046 87.6741 106.996 87.6741 106.953 87.6741",
    fill: "#74877A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.103 87.6813V34.8203C107.161 34.8203 107.218 34.8203 107.282 34.8203V87.6741C107.218 87.6741 107.161 87.6741 107.103 87.6741",
    fill: "#75897C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.282 87.6813V34.8203C107.347 34.8203 107.411 34.8203 107.483 34.8203V87.6741C107.411 87.6741 107.347 87.6741 107.282 87.6741",
    fill: "#778A7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.476 87.6813V34.8203C107.547 34.8203 107.626 34.8203 107.705 34.8203V87.6741C107.626 87.6741 107.547 87.6741 107.476 87.6741",
    fill: "#788C7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.705 87.6813V34.8203C107.79 34.8203 107.876 34.8203 107.962 34.8203V87.6741C107.876 87.6741 107.79 87.6741 107.705 87.6741",
    fill: "#7A8E81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.962 87.6813V34.8203C108.055 34.8203 108.155 34.8203 108.256 34.8203V87.6741C108.155 87.6741 108.062 87.6741 107.962 87.6741",
    fill: "#7B9083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.256 87.6813V34.8203C108.363 34.8203 108.477 34.8203 108.592 34.8203V87.6741C108.477 87.6741 108.363 87.6741 108.256 87.6741",
    fill: "#7D9284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.592 87.6813V34.8203C108.721 34.8203 108.85 34.8203 108.986 34.8203V87.6741C108.85 87.6741 108.721 87.6741 108.592 87.6741",
    fill: "#7F9386"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.986 87.6813V34.8203C109.136 34.8203 109.293 34.8203 109.451 34.8203V87.6741C109.293 87.6741 109.136 87.6741 108.986 87.6741",
    fill: "#809587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.451 87.6813V34.8203C109.637 34.8203 109.83 34.8203 110.016 34.8203V87.6741C109.823 87.6741 109.637 87.6741 109.451 87.6741",
    fill: "#829789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.024 87.6813V34.8203C110.267 34.8203 110.518 34.8203 110.761 34.8203V87.6741C110.518 87.6741 110.267 87.6741 110.024 87.6741",
    fill: "#83998B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.76 87.6813V34.8203C111.104 34.8203 111.44 34.8203 111.762 34.8203V87.6741C111.44 87.6741 111.104 87.6741 110.76 87.6741",
    fill: "#859B8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.762 87.6813V34.8203C112.428 34.8203 113.022 34.8203 113.444 34.8203V87.6741C113.022 87.6741 112.428 87.6741 111.762 87.6741",
    fill: "#869D8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.445 87.6813V34.8203C113.788 34.8203 114.017 34.8203 114.067 34.8203V87.6741C114.017 87.6741 113.788 87.6741 113.445 87.6741",
    fill: "#889E90"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_3191_33571",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 27,
    width: 9,
    height: 8
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.345 33.8424C107.089 32.547 109.78 27.8879 109.923 27.6445C112.485 29.126 114.074 31.8671 114.074 34.8301C113.788 34.8301 108.413 34.8301 106.917 34.8301C106.917 34.4221 106.703 34.05 106.345 33.8496V33.8424Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_3191_33571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.345 33.8424C107.089 32.547 109.78 27.8879 109.923 27.6445C112.486 29.126 114.074 31.8671 114.074 34.8301C113.788 34.8301 108.413 34.8301 106.918 34.8301C106.918 34.4221 106.703 34.05 106.345 33.8496",
    fill: "#89A091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.918 34.8232C106.918 34.4152 106.703 34.0431 106.345 33.8427C106.846 32.9838 108.206 30.6221 109.1 29.0762C109.1 29.1907 109.108 29.3481 109.115 29.4626C109.072 33.2343 113.259 32.6045 113.602 32.3111C113.624 32.2968 113.645 32.2682 113.659 32.2467C113.931 33.0697 114.074 33.9357 114.074 34.8232C113.788 34.8232 108.413 34.8232 106.918 34.8232Z",
    fill: "#89A091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.918 34.8224C106.918 34.4145 106.703 34.0423 106.345 33.8419C106.71 33.2049 107.547 31.7592 108.32 30.4209C108.335 30.4782 108.349 30.5569 108.363 30.6141C108.7 31.7521 108.828 32.1743 109.716 32.6825C110.339 33.0403 112.915 33.8347 114.01 33.8204C114.053 34.1497 114.074 34.486 114.074 34.8296C113.788 34.8296 108.413 34.8296 106.918 34.8296",
    fill: "#889E90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.918 34.8232C106.918 34.4153 106.703 34.0431 106.345 33.8427C106.646 33.3274 107.254 32.2682 107.891 31.166C107.912 31.2447 107.948 31.3449 107.977 31.4237C108.449 32.7548 108.564 33.0698 113.445 34.8232C111.92 34.8232 108.134 34.8232 106.918 34.8232Z",
    fill: "#869D8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.918 34.8222C106.918 34.4143 106.703 34.0421 106.345 33.8417C106.595 33.4123 107.061 32.6036 107.576 31.709C107.576 31.709 107.576 31.7161 107.576 31.7233C107.905 32.4724 108.213 32.9543 108.499 33.169C108.638 33.2692 109.141 33.534 110.009 33.9634C110.596 34.2497 111.183 34.5288 111.763 34.8294C110.024 34.8294 107.791 34.8294 106.91 34.8294",
    fill: "#859B8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.918 34.8225C106.918 34.4146 106.703 34.0424 106.345 33.842C106.553 33.477 106.918 32.8472 107.34 32.1172C107.361 32.1673 107.397 32.2389 107.419 32.289C107.59 32.7112 107.719 33.0404 108.156 33.3696C108.95 33.978 109.888 34.3287 110.746 34.8225C109.236 34.8225 107.626 34.8225 106.91 34.8225",
    fill: "#83998B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.918 34.8237C106.918 34.4158 106.703 34.0436 106.345 33.8432C106.524 33.5355 106.81 33.0416 107.147 32.4619C107.168 32.5049 107.197 32.5621 107.218 32.6051C107.426 33.0917 107.554 33.2921 107.877 33.5498C108.535 34.0722 109.322 34.3871 110.031 34.8309C108.757 34.8309 107.519 34.8309 106.918 34.8309",
    fill: "#829789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.918 34.8229C106.918 34.415 106.703 34.0428 106.345 33.8424C106.495 33.5848 106.717 33.1983 106.982 32.7402C106.996 32.7689 107.011 32.8046 107.025 32.8333C107.254 33.3056 107.325 33.4488 107.626 33.6921C108.184 34.1501 108.85 34.4293 109.444 34.8229C108.385 34.8229 107.419 34.8229 106.91 34.8229",
    fill: "#809587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.918 34.8227C106.918 34.4148 106.703 34.0426 106.345 33.8422C106.467 33.6347 106.638 33.3341 106.846 32.9834C106.86 33.0192 106.882 33.0621 106.903 33.0979C107.025 33.377 107.161 33.6132 107.426 33.8279C107.905 34.2287 108.478 34.4792 108.986 34.8299C108.113 34.8299 107.354 34.8299 106.918 34.8299",
    fill: "#7F9386"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.918 34.8222C106.918 34.4143 106.703 34.0421 106.345 33.8417C106.438 33.6771 106.567 33.4552 106.724 33.1904C106.739 33.2191 106.76 33.262 106.774 33.2906C106.925 33.6055 107.018 33.7487 107.24 33.9419C107.655 34.2926 108.149 34.5216 108.592 34.8294C107.891 34.8294 107.283 34.8294 106.918 34.8294",
    fill: "#7D9284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.918 34.8226C106.918 34.4147 106.703 34.0425 106.345 33.8422C106.417 33.7133 106.51 33.5559 106.617 33.377C106.617 33.3841 106.624 33.3913 106.631 33.3984C106.817 33.7491 106.867 33.8493 107.082 34.0354C107.44 34.3503 107.877 34.5507 108.256 34.8298C107.698 34.8298 107.225 34.8298 106.918 34.8298",
    fill: "#7B9083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.918 34.8224C106.918 34.4145 106.703 34.0423 106.345 33.8419C106.395 33.756 106.452 33.6487 106.524 33.5342C106.538 33.5557 106.553 33.5914 106.567 33.6129C106.638 33.7489 106.731 33.9421 106.939 34.121C107.254 34.393 107.633 34.5719 107.962 34.8296C107.533 34.8296 107.168 34.8296 106.918 34.8296",
    fill: "#7A8E81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.918 34.8228C106.918 34.4149 106.703 34.0427 106.345 33.8423C106.374 33.7922 106.409 33.735 106.438 33.6777C106.452 33.6992 106.467 33.7278 106.474 33.7421C106.538 33.8638 106.631 34.0356 106.81 34.193C107.082 34.4364 107.419 34.5938 107.698 34.8228C107.383 34.8228 107.111 34.8228 106.91 34.8228",
    fill: "#788C7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.917 34.8233C106.917 34.6515 106.882 34.4869 106.81 34.3438C106.824 34.3509 106.839 34.3652 106.846 34.3724C107.053 34.5298 107.268 34.6658 107.476 34.8233C107.254 34.8233 107.068 34.8233 106.917 34.8233Z",
    fill: "#778A7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.917 34.8231C106.917 34.7229 106.903 34.6227 106.875 34.5225C106.875 34.5225 106.889 34.5296 106.889 34.5368C107.018 34.6298 107.154 34.7229 107.275 34.8231C107.139 34.8231 107.018 34.8231 106.91 34.8231",
    fill: "#75897C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.918 34.8229C106.918 34.7727 106.918 34.7153 106.91 34.665C106.925 34.6722 106.946 34.6866 106.953 34.7009C106.997 34.7368 107.061 34.787 107.104 34.8229C107.04 34.8229 106.975 34.8229 106.918 34.8229Z",
    fill: "#74877A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.345 33.8429L106.374 33.7998C106.374 33.7998 106.395 33.8429 106.41 33.8644L106.431 33.9003C106.431 33.9003 106.381 33.8644 106.352 33.85",
    fill: "#778A7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.918 34.8236C106.918 34.8236 106.918 34.8021 106.918 34.7949C106.925 34.8021 106.939 34.8164 106.954 34.8236C106.939 34.8236 106.932 34.8236 106.918 34.8236Z",
    fill: "#728579"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_3191_33571",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 27,
    width: 9,
    height: 8
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0905 34.8193C11.5947 34.8193 6.21987 34.8193 5.93359 34.8193C5.93359 31.8564 7.51527 29.1224 10.0846 27.6338C10.2277 27.8771 12.9187 32.5363 13.6631 33.8317C13.3052 34.0392 13.0905 34.4114 13.0905 34.8193Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_3191_33571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0905 34.8193C11.5947 34.8193 6.21987 34.8193 5.93359 34.8193C5.93359 31.8564 7.51527 29.1224 10.0846 27.6338C10.2277 27.8771 12.9187 32.5363 13.6631 33.8317C13.3052 34.0392 13.0905 34.4114 13.0905 34.8193Z",
    fill: "#7D9284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6631 33.8394C13.3052 34.047 13.0905 34.4191 13.0905 34.8271C11.5947 34.8271 6.21987 34.8271 5.93359 34.8271C5.93359 31.9786 7.40076 29.3377 9.79117 27.8205C9.90568 27.8061 10.0631 27.8061 10.1776 27.8133C10.6929 28.7008 12.9832 32.6657 13.6631 33.8394Z",
    fill: "#7D9284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6631 33.8387C13.3052 34.0462 13.0905 34.4184 13.0905 34.8263C11.5947 34.8263 6.21987 34.8263 5.93359 34.8263C5.93359 32.2928 7.09301 29.9167 9.0397 28.3565C9.61941 28.1919 10.056 28.3064 10.5641 28.471C11.4086 29.9238 13.0977 32.851 13.6631 33.8387Z",
    fill: "#7B9083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6631 33.8388C13.3052 34.0464 13.0905 34.4185 13.0905 34.8265C11.5947 34.8265 6.21987 34.8265 5.93359 34.8265C5.93359 32.615 6.81389 30.5323 8.324 29.0008C9.26872 28.4998 10.5426 29.0151 10.9649 29.1797C11.8595 30.7256 13.1692 32.9943 13.6559 33.8388",
    fill: "#7A8E81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6631 33.8387C13.3052 34.0463 13.0905 34.4184 13.0905 34.8264C11.5947 34.8264 6.21987 34.8264 5.93359 34.8264C5.93359 32.9584 6.5634 31.1835 7.66557 29.7521C8.56018 29.1295 9.80548 29.1581 11.3514 29.838C12.2031 31.3123 13.2408 33.1087 13.6631 33.8387Z",
    fill: "#788C7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6631 33.8385C13.3052 34.046 13.0905 34.4182 13.0905 34.8261C11.5947 34.8261 6.21987 34.8261 5.93359 34.8261C5.93359 33.3303 6.33438 31.8918 7.06439 30.6465C8.0091 29.6374 9.90568 29.5443 11.6878 30.4318C12.4607 31.7701 13.2981 33.2158 13.6631 33.8456",
    fill: "#778A7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6631 33.8379C13.3052 34.0455 13.0905 34.4177 13.0905 34.8256C11.5947 34.8256 6.21987 34.8256 5.93359 34.8256C5.93359 33.7306 6.1483 32.6714 6.54909 31.6909C7.18605 30.6531 9.16136 29.5939 11.9955 30.9465C12.6754 32.1203 13.3482 33.2869 13.6631 33.8379Z",
    fill: "#75897C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6631 33.8382C13.3052 34.0457 13.0905 34.4179 13.0905 34.8258C11.5947 34.8258 6.21987 34.8258 5.93359 34.8258C5.93359 34.1889 6.00516 33.5662 6.1483 32.9579C6.89262 31.1042 9.39038 30.0235 12.2603 31.4191C12.84 32.4283 13.3839 33.3658 13.6631 33.8453",
    fill: "#74877A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6631 33.8386C13.3052 34.0461 13.0905 34.4183 13.0905 34.8262C11.5947 34.8262 6.21987 34.8262 5.93359 34.8262C5.93359 34.7332 5.93359 34.633 5.93359 34.5399C6.27713 32.0207 9.28303 30.2529 12.4965 31.8418C12.9832 32.6863 13.4197 33.4378 13.6559 33.8457",
    fill: "#728579"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6631 33.8386C13.3052 34.0462 13.0905 34.4183 13.0905 34.8263C11.7665 34.8263 7.37214 34.8263 6.20557 34.8263C7.10018 31.6486 10.285 30.9973 12.7184 32.214C13.112 32.9011 13.4555 33.4951 13.6559 33.8386",
    fill: "#718377"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6631 33.8389C13.3052 34.0464 13.0905 34.4186 13.0905 34.8265C11.9096 34.8265 8.30969 34.8265 6.70654 34.8265C7.82302 31.9924 10.743 31.4484 12.9187 32.5578C13.2265 33.0945 13.4913 33.5526 13.6631 33.8389Z",
    fill: "#6F8175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6631 33.8387C13.3053 34.0463 13.0906 34.4184 13.0906 34.8264C12.0457 34.8264 9.08986 34.8264 7.31494 34.8264C8.54593 32.2427 11.2155 31.892 13.1049 32.8725C13.3339 33.2733 13.5343 33.6097 13.6631 33.8387Z",
    fill: "#6D8074"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6631 33.8389C13.3052 34.0465 13.0905 34.4186 13.0905 34.8266C12.1673 34.8266 9.75538 34.8266 7.98047 34.8266C9.19714 32.5793 11.6162 32.293 13.2694 33.159C13.4269 33.431 13.5629 33.6672 13.6631 33.8389Z",
    fill: "#6C7E72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6632 33.8388C13.3053 34.0464 13.0906 34.4186 13.0906 34.8265C12.2819 34.8265 10.3352 34.8265 8.6748 34.8265C9.92011 32.8011 12.0099 32.6794 13.4198 33.4237C13.5129 33.5812 13.5916 33.7243 13.656 33.8388",
    fill: "#6A7C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6631 33.8389C13.3052 34.0464 13.0905 34.4186 13.0905 34.8265C12.3963 34.8265 10.8647 34.8265 9.39038 34.8265C10.5355 33.1375 12.3104 33.0302 13.5629 33.6671C13.5986 33.7315 13.6344 33.7888 13.6631 33.8389Z",
    fill: "#697A6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0906 34.819C12.5109 34.819 11.3514 34.819 10.1348 34.819C10.9721 33.6595 12.3105 33.2874 13.6345 33.8528C13.2981 34.0603 13.0977 34.4253 13.0977 34.819",
    fill: "#67786D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0904 34.8193C12.6466 34.8193 11.8522 34.8193 10.9504 34.8193C11.387 34.304 12.117 33.6599 13.4697 33.9677C13.2263 34.1824 13.0832 34.4901 13.0832 34.8193",
    fill: "#66766B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_3191_33571",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 1,
    width: 50,
    height: 33
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6624 33.8383C12.9181 32.5429 10.22 27.8838 10.084 27.6404L55.8596 1.20996C56.0028 1.4533 58.6938 6.11245 59.4381 7.40785L13.6624 33.8312V33.8383Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_3191_33571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.4383 7.40875L13.6626 33.8392C13.634 33.7891 13.5982 33.7319 13.5696 33.6746L59.3381 7.24414C59.3738 7.3014 59.4025 7.35865 59.4311 7.40875",
    fill: "#697A6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.338 7.24431L13.5623 33.6676C13.5194 33.5961 13.4693 33.5102 13.4192 33.4243L59.202 7.00098C59.2521 7.08686 59.3022 7.17274 59.3451 7.24431",
    fill: "#6A7C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2023 7.00113L13.4267 33.4316C13.3766 33.3457 13.3265 33.2599 13.2764 33.1668L59.0448 6.73633C59.1021 6.82937 59.1522 6.91525 59.1951 7.00113",
    fill: "#6C7E72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0445 6.73647L13.2689 33.167C13.2188 33.0739 13.1615 32.9809 13.1042 32.8807L58.8799 6.4502C58.9371 6.55039 58.9944 6.65059 59.0445 6.73647Z",
    fill: "#6D8074"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8798 6.44967L13.1042 32.873C13.047 32.7728 12.9825 32.6655 12.9253 32.5581L58.6938 6.13477C58.7582 6.24212 58.8154 6.34947 58.8727 6.44967",
    fill: "#6F8175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.694 6.13552L12.9184 32.5589C12.854 32.4443 12.7896 32.3298 12.718 32.2153L58.5008 5.79199C58.5724 5.9065 58.6368 6.02817 58.7012 6.13552",
    fill: "#718377"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5007 5.79143L12.725 32.2148C12.6535 32.0931 12.5819 31.9643 12.5032 31.8354L58.2788 5.41211C58.3504 5.54093 58.4291 5.66976 58.5007 5.79143Z",
    fill: "#728579"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.279 5.41249L12.5033 31.8358C12.4246 31.6998 12.3459 31.5567 12.26 31.4136L58.0356 4.99023C58.1144 5.13337 58.2003 5.26935 58.279 5.41249Z",
    fill: "#74877A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0354 4.98961L12.2598 31.4129C12.1739 31.2555 12.0808 31.1052 11.9878 30.9477L57.7634 4.52441C57.8565 4.68187 57.9423 4.83932 58.0354 4.98961Z",
    fill: "#75897C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7637 4.52441L11.9881 30.9477C11.8879 30.776 11.7877 30.597 11.6875 30.4253L57.4631 4.00195C57.5633 4.17372 57.6635 4.35264 57.7637 4.52441Z",
    fill: "#778A7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4632 4.00223L11.6875 30.4256C11.573 30.2252 11.4585 30.0319 11.344 29.8387L57.1268 3.4082C57.2341 3.60144 57.3486 3.79468 57.4632 3.99507",
    fill: "#788C7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1264 3.40812L11.3508 29.8386C11.2219 29.6096 11.0931 29.3949 10.9714 29.1873L56.7471 2.75684C56.8687 2.96439 56.9904 3.18625 57.1264 3.40812Z",
    fill: "#7A8E81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7471 2.75768L10.9715 29.1882C10.8212 28.9234 10.6781 28.6872 10.5564 28.4725L56.3392 2.04199C56.4609 2.24954 56.5968 2.49288 56.7543 2.75768",
    fill: "#7B9083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3392 2.04223L10.5564 28.4727C10.3918 28.1864 10.2558 27.9574 10.1699 27.8071L55.9527 1.38379C56.0386 1.52693 56.1674 1.76311 56.3392 2.04938",
    fill: "#7D9284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.953 1.3827L10.1773 27.806L10.0771 27.6343L55.8599 1.21094L55.9601 1.3827",
    fill: "#7F9386"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_3191_33571",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 1,
    width: 50,
    height: 33
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5692 7.40785C61.3135 6.11245 64.0116 1.4533 64.1476 1.20996L109.923 27.6404C109.78 27.8838 107.089 32.5429 106.345 33.8383L60.562 7.40785H60.5692Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_3191_33571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.345 33.84L60.5691 7.40947L60.5977 7.35938L106.381 33.7899L106.352 33.84",
    fill: "#778A7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.373 33.7891L60.5906 7.36581C60.612 7.33002 60.6335 7.28708 60.6621 7.24414L106.445 33.6746C106.423 33.7176 106.395 33.7605 106.373 33.7963",
    fill: "#788C7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.445 33.6684L60.6624 7.23786C60.691 7.19492 60.7125 7.14482 60.7411 7.09473L106.524 33.5252C106.495 33.5753 106.467 33.6254 106.445 33.6684Z",
    fill: "#7A8E81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.524 33.5313L60.748 7.10081C60.7767 7.05071 60.8053 7.00061 60.8411 6.94336L106.624 33.3738C106.595 33.4311 106.559 33.4812 106.531 33.5313",
    fill: "#7B9083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.617 33.3744L60.834 6.94389C60.8698 6.88664 60.9056 6.82222 60.9413 6.75781L106.724 33.1883C106.688 33.2527 106.653 33.3171 106.617 33.3744Z",
    fill: "#7D9284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.724 33.1878L60.9412 6.75736C60.9769 6.69294 61.0199 6.62137 61.0628 6.5498L106.846 32.9803C106.803 33.0519 106.767 33.1234 106.724 33.1878Z",
    fill: "#7F9386"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.846 32.9733L61.063 6.54282C61.1059 6.46409 61.156 6.38537 61.199 6.30664L106.982 32.7371C106.932 32.8159 106.889 32.9017 106.846 32.9733Z",
    fill: "#809587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.982 32.7373L61.2061 6.30678C61.2562 6.21374 61.3134 6.1207 61.3707 6.02051L107.153 32.451C107.096 32.5512 107.039 32.6442 106.989 32.7373",
    fill: "#829789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.146 32.4505L61.3708 6.01997C61.4353 5.91262 61.4997 5.7981 61.5641 5.68359L107.347 32.1141C107.282 32.2286 107.218 32.3431 107.154 32.4505",
    fill: "#83998B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.347 32.108L61.564 5.68463C61.6427 5.54865 61.7214 5.41267 61.8001 5.26953L107.583 31.7C107.504 31.8432 107.418 31.9791 107.347 32.1151",
    fill: "#859B8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.583 31.6929L61.8071 5.26953C61.9073 5.09776 62.0075 4.91884 62.1077 4.74707L107.891 31.1776C107.79 31.3565 107.69 31.5282 107.59 31.7",
    fill: "#869D8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.883 31.1693L62.1077 4.73878C62.2508 4.48829 62.4011 4.2378 62.5442 3.9873L108.32 30.4178C108.177 30.6683 108.026 30.9188 107.883 31.1693Z",
    fill: "#889E90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.32 30.4186L62.5444 3.98806C62.8236 3.50139 63.0955 3.02904 63.3389 2.62109L109.114 29.0516C108.878 29.4667 108.606 29.9319 108.327 30.4186",
    fill: "#89A091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.115 29.0513L63.3318 2.62085C63.7755 1.85506 64.0976 1.29682 64.1477 1.21094L109.923 27.6414C109.873 27.7202 109.551 28.2856 109.107 29.0513",
    fill: "#8BA293"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0037 7.25977C60.2041 7.25977 60.3901 7.30986 60.5691 7.41006C75.8276 16.2202 91.0933 25.0304 106.352 33.8405C106.703 34.0481 106.924 34.4203 106.924 34.821V87.6749C106.924 88.0828 106.71 88.455 106.352 88.6625C91.0933 97.4727 75.8348 106.283 60.5762 115.086C60.3973 115.186 60.2041 115.236 60.0108 115.236C59.8104 115.236 59.6243 115.186 59.4454 115.086C44.1869 106.276 28.9212 97.4655 13.6626 88.6554C13.312 88.4478 13.0901 88.0757 13.0901 87.6749V34.821C13.0901 34.4131 13.3048 34.0409 13.6626 33.8334C28.9212 25.0232 44.1797 16.2131 59.4383 7.41006C59.6172 7.30986 59.8104 7.25977 60.0037 7.25977Z",
    fill: "#819688"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_3191_33571",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 0,
    width: 6,
    height: 8
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4383 7.40975C58.694 6.11435 56.003 1.4552 55.8599 1.21186C57.141 0.474699 58.5723 0.102539 60.0037 0.102539V7.25945C59.8033 7.25945 59.6172 7.30955 59.4383 7.40975Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_3191_33571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.4383 7.40975C58.694 6.11435 56.003 1.4552 55.8599 1.21186C57.141 0.474699 58.5723 0.102539 60.0037 0.102539V7.25945C59.8033 7.25945 59.6172 7.30955 59.4383 7.40975Z",
    fill: "#83998B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0037 7.25982C59.8033 7.25982 59.6172 7.30991 59.4383 7.41011C58.694 6.11471 56.003 1.45556 55.8599 1.21222C56.8475 0.639669 57.9282 0.288981 59.0304 0.160156C59.059 0.181627 59.0876 0.203098 59.1163 0.224568C59.4741 0.582414 59.7962 1.19791 60.0037 1.60585V7.26697",
    fill: "#83998B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0037 7.25829C59.8033 7.25829 59.6172 7.30839 59.4383 7.40859C58.694 6.11319 56.003 1.45403 55.8599 1.2107C56.5684 0.802756 57.3199 0.509322 58.0928 0.323242C58.1214 0.337556 58.1644 0.35187 58.193 0.366184C58.7441 0.731186 59.3381 1.50413 60.0109 2.72797V7.25829",
    fill: "#829789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0037 7.25911C59.8033 7.25911 59.6172 7.30921 59.4383 7.40941C58.694 6.11401 56.003 1.45485 55.8599 1.21152C56.2964 0.961027 56.7473 0.753476 57.2054 0.588867C57.2411 0.596024 57.2912 0.610338 57.327 0.617495C57.9211 0.825045 58.9302 1.7125 60.0037 3.56614V7.26627",
    fill: "#809587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0037 7.25954C59.8033 7.25954 59.6172 7.30964 59.4383 7.40983C58.694 6.11443 56.003 1.45528 55.8599 1.21194C56.0245 1.11175 56.1962 1.02586 56.368 0.93998C57.3199 0.861254 59.1592 2.67195 60.0037 4.21785V7.25954Z",
    fill: "#7F9386"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0037 7.25896C59.8033 7.25896 59.6172 7.30906 59.4383 7.40926C58.7584 6.22837 56.4682 2.26343 55.9529 1.37598C55.96 1.37598 55.9744 1.37598 55.9815 1.37598C57.7851 1.66225 59.5814 3.98109 59.9965 4.74688V7.24465",
    fill: "#7D9284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0037 7.25938C59.8033 7.25938 59.6172 7.30948 59.4383 7.40968C58.8729 6.42918 57.1767 3.49485 56.3394 2.04199C56.4109 2.07062 56.504 2.09925 56.5755 2.12788C58.1143 2.75053 59.5099 4.30358 60.0109 5.21251V7.25938",
    fill: "#7B9083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0037 7.25983C59.8033 7.25983 59.6172 7.30993 59.4383 7.41013C58.9516 6.56561 57.6419 4.29687 56.7473 2.75098C56.8189 2.7796 56.9048 2.82255 56.9763 2.85117C58.787 3.78157 59.696 5.07697 60.0037 5.59227V7.25268",
    fill: "#7A8E81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0038 7.2596C59.8034 7.2596 59.6173 7.3097 59.4384 7.4099C59.0161 6.67989 57.9784 4.8835 57.1267 3.40918C57.1911 3.43781 57.277 3.48075 57.3414 3.50938C58.5223 4.16066 59.4169 4.97654 60.0038 5.93557V7.2596Z",
    fill: "#788C7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0038 7.25965C59.8034 7.25965 59.6173 7.30975 59.4384 7.40994C59.0734 6.77298 58.236 5.33444 57.4702 3.99609C57.5132 4.01756 57.5704 4.04619 57.6134 4.06766C58.1573 4.32531 59.2738 5.07679 60.0038 6.22905V7.25965Z",
    fill: "#778A7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0037 7.25965C59.8033 7.25965 59.6172 7.30975 59.4383 7.40995C59.1234 6.85887 58.4507 5.69229 57.7708 4.51855C58.286 4.76905 59.2522 5.35591 60.0037 6.48671V7.2525",
    fill: "#75897C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0037 7.2593C59.8033 7.2593 59.6172 7.3094 59.4383 7.40959C59.1592 6.93008 58.6224 5.99252 58.0427 4.9834C58.0928 5.00487 58.1501 5.04065 58.2002 5.06212C58.5222 5.2482 59.3739 5.75635 60.0109 6.72253V7.25214",
    fill: "#74877A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0036 7.25891C59.8032 7.25891 59.6172 7.30901 59.4382 7.40921C59.2021 7.00127 58.7655 6.24979 58.2788 5.40527C58.3218 5.42674 58.379 5.45537 58.4219 5.47684C58.9372 5.78459 59.4812 6.17106 60.0036 6.9297V7.25891Z",
    fill: "#728579"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0037 7.25948C59.8033 7.25948 59.6172 7.30958 59.4383 7.40978C59.2379 7.05909 58.8944 6.47222 58.5007 5.78516C58.5365 5.80663 58.5866 5.8281 58.6224 5.84957C59.2236 6.21457 59.5957 6.55095 60.0037 7.10919V7.25232",
    fill: "#718377"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4383 7.40902C59.2737 7.12274 59.0089 6.6647 58.7012 6.12793C58.737 6.1494 58.7799 6.17087 58.8085 6.18518C59.3668 6.52156 59.6459 6.80784 59.9966 7.25157C59.8033 7.25157 59.6173 7.30166 59.4383 7.40186",
    fill: "#6F8175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4384 7.40954C59.3024 7.18052 59.1091 6.84415 58.8801 6.44336C58.9088 6.45767 58.9445 6.47914 58.9732 6.50061C59.3382 6.72248 59.5672 6.91572 59.8749 7.26641C59.7246 7.28072 59.5744 7.33082 59.4312 7.40954",
    fill: "#6D8074"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4383 7.40908C59.3381 7.23731 59.2021 7.00829 59.0447 6.73633C59.0661 6.75064 59.1019 6.77211 59.1234 6.78643C59.3667 6.93672 59.5385 7.06555 59.7604 7.28741C59.6459 7.30888 59.5313 7.35182 59.4312 7.41623",
    fill: "#6C7E72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4383 7.40892C59.3739 7.29441 59.2952 7.15843 59.2021 7.00098C59.2236 7.01529 59.2522 7.0296 59.2737 7.04392C59.3882 7.11549 59.4741 7.16559 59.6602 7.31588C59.5886 7.33735 59.5099 7.37314 59.4383 7.41608",
    fill: "#6A7C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4389 7.41018C59.4101 7.35994 59.3743 7.30253 59.3384 7.24512C59.3527 7.25229 59.3814 7.26665 59.3958 7.281C59.446 7.30971 59.4891 7.33841 59.5321 7.35994C59.4963 7.3743 59.4676 7.39583 59.4317 7.41018",
    fill: "#697A6F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_3191_33571",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 0,
    width: 5,
    height: 8
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0037 7.25945V0.102539C61.435 0.102539 62.8664 0.474699 64.1475 1.21186C64.0044 1.4552 61.3134 6.11435 60.5691 7.40975C60.3973 7.30955 60.2041 7.25945 60.0037 7.25945Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_3191_33571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.0037 7.25945V0.102539C61.435 0.102539 62.8664 0.474699 64.1475 1.21186C64.0044 1.4552 61.3134 6.11435 60.5691 7.40975C60.3973 7.30955 60.2041 7.25945 60.0037 7.25945Z",
    fill: "#89A091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5691 7.40975C60.3973 7.30955 60.2041 7.25945 60.0037 7.25945V0.102539C61.3277 0.102539 62.6446 0.417443 63.8469 1.04725C63.8255 1.06157 63.7968 1.07588 63.7682 1.09019C63.3531 1.51961 63.3173 2.62893 63.3173 2.64324C62.4227 4.18914 61.0629 6.55092 60.5619 7.40975",
    fill: "#89A091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5691 7.40975C60.3973 7.30955 60.2041 7.25945 60.0037 7.25945V0.102539C60.7981 0.102539 61.5853 0.21705 62.3583 0.446071C62.3583 0.467542 62.344 0.496169 62.344 0.51764C62.2963 0.803917 62.3654 1.96334 62.5515 3.9959C61.7786 5.33424 60.9412 6.77994 60.5762 7.41691",
    fill: "#889E90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5691 7.40975C60.3973 7.30955 60.2041 7.25945 60.0037 7.25945V0.102539C60.3758 0.102539 60.7551 0.131167 61.1273 0.181265C61.1273 0.202736 61.1416 0.23852 61.1488 0.259991L62.1078 4.74022C61.4708 5.83523 60.8625 6.89445 60.5619 7.41691",
    fill: "#869D8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5691 7.40975C60.3973 7.30955 60.2041 7.25945 60.0037 7.25945V0.102539C60.0037 0.102539 60.0609 0.152637 60.0895 0.174108C60.7981 1.355 61.8001 5.2412 61.8072 5.26983C61.2919 6.16445 60.8267 6.97318 60.5762 7.40259",
    fill: "#859B8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5691 7.40973C60.3973 7.30953 60.2041 7.25943 60.0037 7.25943V1.60547C60.0251 1.64841 60.0538 1.71282 60.0752 1.75576C60.519 2.57165 61.2347 4.5398 61.5567 5.69207C61.1345 6.41492 60.7695 7.05188 60.5619 7.41688",
    fill: "#83998B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5691 7.41011C60.3973 7.30992 60.2041 7.25982 60.0037 7.25982V2.72949C60.0394 2.7939 60.0895 2.88694 60.1253 2.95136C60.4689 3.63842 60.9341 4.58313 61.3635 6.02167C61.0271 6.60138 60.7408 7.10237 60.5619 7.40296",
    fill: "#829789"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5691 7.40967C60.3973 7.30947 60.2041 7.25937 60.0037 7.25937V3.56641C60.0394 3.62366 60.0824 3.69523 60.1182 3.75249C60.884 5.23397 61.1488 6.08564 61.206 6.3075C60.9412 6.76555 60.7194 7.15202 60.5691 7.40967Z",
    fill: "#809587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5691 7.40878C60.3973 7.30858 60.2041 7.25849 60.0037 7.25849V4.2168C60.0251 4.25974 60.0609 4.30984 60.0895 4.35278C60.4545 4.90386 60.9627 6.20642 61.07 6.54279C60.8625 6.90064 60.6907 7.19407 60.5691 7.40878Z",
    fill: "#7F9386"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5691 7.40978C60.3973 7.30958 60.2041 7.25948 60.0037 7.25948V4.76172C60.0037 4.76172 60.018 4.79035 60.0323 4.80466C60.3186 5.22692 60.7408 6.15732 60.9484 6.7585C60.7981 7.0233 60.6693 7.24517 60.5691 7.40978Z",
    fill: "#7D9284"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5691 7.41006C60.3973 7.30987 60.2041 7.25977 60.0037 7.25977V5.21289C60.0037 5.21289 60.0108 5.2272 60.018 5.23436C60.4045 5.7926 60.7909 6.80888 60.841 6.93771C60.7337 7.12379 60.6406 7.28124 60.5691 7.40291",
    fill: "#7B9083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5691 7.40933C60.3973 7.30914 60.2041 7.25904 60.0037 7.25904V5.59863C60.0037 5.59863 60.0251 5.63442 60.0394 5.64873C60.2685 5.98511 60.5619 6.61492 60.748 7.09443C60.6836 7.20894 60.6192 7.31629 60.5691 7.40218",
    fill: "#7A8E81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5691 7.40987C60.3973 7.30967 60.2041 7.25958 60.0037 7.25958V5.93555C60.0037 5.93555 60.0466 5.99996 60.0609 6.02143C60.3186 6.458 60.3758 6.57967 60.6621 7.23811C60.6263 7.30252 60.5977 7.35262 60.5619 7.40987",
    fill: "#788C7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5691 7.41006C60.3973 7.30987 60.2041 7.25977 60.0037 7.25977V6.23633C60.0037 6.23633 60.0395 6.28643 60.0538 6.31505C60.1396 6.45819 60.3186 6.80888 60.5905 7.36712C60.5905 7.36712 60.5691 7.39575 60.5619 7.41006",
    fill: "#778A7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0037 7.25961V6.50098C60.0037 6.50098 60.0323 6.54392 60.0466 6.56539C60.1182 6.68467 60.2613 6.95186 60.476 7.36696C60.3257 7.29539 60.1683 7.26677 60.0037 7.26677",
    fill: "#75897C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0037 7.2591V6.72949C60.1182 6.8941 60.2041 7.0444 60.34 7.3092C60.2327 7.27342 60.1182 7.2591 60.0037 7.2591Z",
    fill: "#74877A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0037 7.26045V6.9375C60.0037 6.9375 60.0252 6.97338 60.0395 6.98774C60.1041 7.08103 60.1615 7.1815 60.219 7.28198C60.1472 7.26762 60.0754 7.26045 60.0037 7.26045Z",
    fill: "#728579"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0037 7.25877V7.11523C60.0037 7.11523 60.0252 7.14394 60.0324 7.15829C60.0539 7.19418 60.0826 7.22288 60.1041 7.25877C60.0683 7.25877 60.0395 7.25877 60.0037 7.25877Z",
    fill: "#718377"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M115.327 103.525H4.67371C2.09263 103.525 0.000244141 105.618 0.000244141 108.199V126.843C0.000244141 129.424 2.09263 131.516 4.67371 131.516H115.327C117.908 131.516 120 129.424 120 126.843V108.199C120 105.618 117.908 103.525 115.327 103.525Z",
    fill: "#192227"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3969 122.034L30.2167 125.985L24.1548 122.736L24.1763 120.31L27.3969 122.034Z",
    fill: "#BC934E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1763 120.31L24.1548 122.736L18.0356 125.892L20.9199 121.984L24.1763 120.31Z",
    fill: "#CEA256"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8027 118.429L29.1073 119.202L30.2166 125.986L27.3968 122.036L26.8027 118.429Z",
    fill: "#F8C267"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9199 121.984L18.0356 125.892L19.2523 119.122L21.564 118.392L20.9199 121.984Z",
    fill: "#C39951"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4508 115.895L34.0742 114.435L29.1073 119.201L26.8027 118.428L29.4508 115.895Z",
    fill: "#D7A95A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5639 118.392L19.2522 119.122L14.364 114.276L18.9659 115.815L21.5639 118.392Z",
    fill: "#BB924E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8296 115.336L27.2681 113.39L34.0744 114.435L29.451 115.895L25.8296 115.336Z",
    fill: "#F3BF65"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9662 115.815L14.3643 114.276L21.1776 113.339L22.5876 115.314L18.9662 115.815Z",
    fill: "#EAB761"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5874 115.314L21.1775 113.339L24.2764 107.198L24.2335 112.043L22.5874 115.314Z",
    fill: "#C99E54"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2336 112.043L25.8295 115.335L29.4509 115.893L26.8029 118.427L27.3969 122.034L24.1763 120.309L20.9199 121.984L21.564 118.391L18.9661 115.815L22.5875 115.314L24.2336 112.043Z",
    fill: "#E9B761"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2336 112.043L24.2766 107.198L27.2682 113.389L25.8296 115.336L24.2336 112.043Z",
    fill: "#FDC669"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1814 122.042L66.0012 125.985L59.9321 122.736L59.9536 120.31L63.1814 122.042Z",
    fill: "#BC934E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9535 120.31L59.9321 122.736L53.8201 125.892L56.7043 121.984L59.9535 120.31Z",
    fill: "#CEA256"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5945 118.429L64.8919 119.202L66.0012 125.986L63.1813 122.043L62.5945 118.429Z",
    fill: "#F8C267"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7043 121.984L53.8201 125.892L55.0367 119.122L57.3484 118.392L56.7043 121.984Z",
    fill: "#C39951"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2354 115.895L69.8516 114.435L64.8919 119.201L62.5945 118.428L65.2354 115.895Z",
    fill: "#D7A95A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3485 118.392L55.0369 119.122L50.1487 114.276L54.7506 115.815L57.3485 118.392Z",
    fill: "#BB924E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6143 115.336L63.0528 113.39L69.8519 114.435L65.2357 115.895L61.6143 115.336Z",
    fill: "#F3BF65"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7506 115.815L50.1487 114.276L56.9621 113.339L58.372 115.314L54.7506 115.815Z",
    fill: "#EAB761"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3721 115.314L56.9622 113.339L60.054 107.198L60.0182 112.051L58.3721 115.314Z",
    fill: "#C99E54"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M60.018 112.051L61.614 115.336L65.2354 115.894L62.5945 118.428L63.1813 122.042L59.9536 120.31L56.7043 121.985L57.3484 118.392L54.7505 115.815L58.3719 115.314L60.018 112.051Z",
    fill: "#E9B761"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0183 112.051L60.0541 107.198L63.0528 113.389L61.6143 115.336L60.0183 112.051Z",
    fill: "#FDC669"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9662 122.034L101.786 125.985L95.7241 122.736L95.7384 120.31L98.9662 122.034Z",
    fill: "#BC934E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7384 120.31L95.7241 122.736L89.6121 125.892L92.4891 121.984L95.7384 120.31Z",
    fill: "#CEA256"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3721 118.429L100.677 119.202L101.786 125.986L98.9661 122.036L98.3721 118.429Z",
    fill: "#F8C267"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4891 121.984L89.6121 125.892L90.8216 119.122L93.1333 118.392L92.4891 121.984Z",
    fill: "#C29951"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M101.02 115.895L105.643 114.435L100.677 119.201L98.3721 118.428L101.02 115.895Z",
    fill: "#D7A95A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1335 118.392L90.8218 119.122L85.9336 114.276L90.5355 115.815L93.1335 118.392Z",
    fill: "#BB924E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3989 115.336L98.8375 113.39L105.644 114.435L101.02 115.895L97.3989 115.336Z",
    fill: "#F3BF65"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5355 115.815L85.9336 114.276L92.7541 113.339L94.1641 115.314L90.5355 115.815Z",
    fill: "#EAB761"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1641 115.314L92.7542 113.339L95.8459 107.198L95.8101 112.051L94.1641 115.314Z",
    fill: "#C99E54"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M95.81 112.051L97.3989 115.336L101.02 115.894L98.3722 118.428L98.9662 122.035L95.7385 120.31L92.4892 121.985L93.1334 118.392L90.5354 115.815L94.164 115.314L95.81 112.051Z",
    fill: "#E9B761"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8101 112.051L95.8458 107.198L98.8374 113.389L97.3989 115.336L95.8101 112.051Z",
    fill: "#FDC669"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6504 56.5C68.855 54.4875 70.9731 50.9328 70.9731 46.875C70.9731 40.5969 65.8589 35.5 59.5595 35.5C53.2601 35.5 48.1459 40.5969 48.1459 46.875C48.1459 50.9328 50.275 54.4875 53.4686 56.5H52.5358C50.5933 56.5 49.0239 58.0641 49.0239 60C49.0239 61.8047 50.3957 63.2812 52.1517 63.4781L50.7798 75.75H68.3392L66.9673 63.4781C68.7233 63.2812 70.0951 61.8047 70.0951 60C70.0951 58.0641 68.5257 56.5 66.5832 56.5H65.6504ZM44.4804 83.7781C44.0195 84.2375 43.7561 84.8719 43.7561 85.5281C43.7561 86.8953 44.8645 88 46.2364 88H72.8826C74.2545 88 75.3629 86.8953 75.3629 85.5281C75.3629 84.8719 75.0995 84.2375 74.6386 83.7781L70.0951 79.25H49.0239L44.4804 83.7781Z",
    fill: "#CEDFD5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergenteTres);
export default __webpack_public_path__ + "static/media/emergenteTres.305c84af61b83e38176675cc7e9f1bde.svg";
export { ForwardRef as ReactComponent };